import React, {Key} from 'react';
import {SizeType} from 'antd/es/config-provider/SizeContext';
import {ProTableColumnType} from './index';

export type ColumnTypeWithKey<RecordType> = RequiredKey<
    ProTableColumnType<RecordType>,
    'key'
>;

export interface ProTableContextProps<RecordType = any> {
    size: SizeType; // 表格尺寸
    setSize: (size: SizeType) => void; // 设置表格尺寸
    visibleColumnKeys: Key[]; // 可见列key
    setVisibleColumnKeys: (keys: Key[]) => void; // 设置可见列key
    sortedColumnKeys: Key[]; // 列key排序
    setSortedColumnKeys: (keys: Key[]) => void; // 设置列key排序
    columns: ColumnTypeWithKey<RecordType>[];
}

const defaultContext: ProTableContextProps<unknown> = {
    size: 'large',
    setSize: () => null,
    visibleColumnKeys: [],
    setVisibleColumnKeys: () => null,
    sortedColumnKeys: [],
    setSortedColumnKeys: () => null,
    columns: [],
};

export const ProTableContext =
    React.createContext<ProTableContextProps>(defaultContext);
